import React from "react";
import {
  HomeSlider,
  TopProgrammes,
  PeopleBehind,
  EventGallery,
  // OurNews,
  VisionSection,
  MissionSection,
  PhotoGallery2,
  FoundationFacts,
  MoreAboutFoundation,
  AudioSection,
  BookSection,
  Certificates,
  NewsArticles,
} from "../components/index";
import HeroEventSlider from "../components/HomeComponents/HeroEventSlider/HeroEventSlider";

const HomePage = () => {
  return (
    <>
      <div className="App">
        <HeroEventSlider />
        <HomeSlider />
        <TopProgrammes />
        <BookSection />
        <PeopleBehind />
        <EventGallery />
        <VisionSection />
        <NewsArticles />
        {/* <OurNews /> */}
        <MissionSection />
        <Certificates/>
        <PhotoGallery2 />
        <FoundationFacts />
        <MoreAboutFoundation />
        <AudioSection />
      </div>
    </>
  );
};

export default HomePage;
